/**
 * Снимок модели для карточки каталога, снятый в браузере: url картинки, `null` — модель не
 * снялась, `undefined` — снимок ещё делается (карточка показывает символ с плана). Готовую
 * картинку рядом с моделью (`staticThumbUrl`) карточка берёт сама — сюда идут, только если её нет.
 */
import { useEffect } from "react";
import type { View3D } from "@/shared/catalog";
import { requestThumb, thumbKey, useThumbsStore } from "../thumbs";

export const useModelThumb = (view3d: View3D | undefined): string | null | undefined => {
	const key = view3d ? thumbKey(view3d) : null;
	const url = useThumbsStore((s) => (key === null ? null : s.urls[key]));
	useEffect(() => {
		// Обработчик синхронный — поиск в кэше идёт сам, ошибки он глотает внутри
		if (view3d && url === undefined) void requestThumb(view3d);
	}, [view3d, url]);
	return url;
};
